// import React, { useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import styles from "../CommonStyles/commonstylesDetails.module.scss";
// import { useFetchPartnerDetails } from "../../../../hooks/partnerHook/usePartner";
// import { useDeleteCertificate } from "../../../../hooks/partnerHook/usePartnerCertificates";
// import { RiDeleteBin5Line } from "react-icons/ri";
// import DeleteBox from "../../../../components/DeleteBox/DeleteBox";
// import { useSelector } from "react-redux";

// const CertificateDetails = () => {
//   const { certificateId } = useParams();
//   const navigate = useNavigate();
//   const { data: partnerData, isLoading, isError } = useFetchPartnerDetails();

//   const certificate = useSelector((state) =>
//     state.partner.certificates.find(
//       (cert) => cert.certificate_id.toString() === certificateId
//     )
//   );

//   const {
//     mutate: deleteCertificate,
//     isSuccess: certificateDeleted,
//     isError: deletionError,
//   } = useDeleteCertificate();

//   const [showDeleteModal, setShowDeleteModal] = useState(false);

//   if (isLoading) return <h2>Loading Certificate Details...</h2>;
//   if (isError || !certificate) return <h2>Error: Certificate not found!</h2>;

//   const handleDelete = () => {
//     if (certificateId) {
//       deleteCertificate({ partnerId: partnerData.partner.id, certificateId });
//       setShowDeleteModal(false);
//       navigate("/dashboard/certificates");
//     }
//   };

//   return (
//     <div className={styles.detailsContainer}>
//       <div className={styles.titleContainer}>
//         <h2 className={styles.equipmentTitle}>{certificate.title}</h2>
//         <RiDeleteBin5Line
//           className={styles.deleteIcon}
//           onClick={() => setShowDeleteModal(true)}
//         />
//       </div>

//       <div className={styles.imageCard}>
//         <img
//           src={certificate.media?.[0]?.media_url || "/default-image.jpg"}
//           alt={certificate.title}
//           className={styles.equipmentImage}
//         />
//         <span
//           className={`${styles.verificationStatus} ${
//             certificate.verification_status === "success"
//               ? styles.verified
//               : styles.notVerified
//           }`}
//         >
//           {certificate.verification_status === "success"
//             ? "Verified"
//             : "Not Verified"}
//         </span>
//       </div>

//       <div className={styles.equipmentDetails}>
//         <div className={styles.detailItem}>
//           <strong>Certificate Number:</strong>{" "}
//           <span>{certificate.certificate_number}</span>
//         </div>
//         <div className={styles.detailItem}>
//           <strong>Training Institute Name:</strong>{" "}
//           <span>{certificate.institute_name}</span>
//         </div>
//         <div className={styles.detailItem}>
//           <strong>Training Authorization Number:</strong>{" "}
//           <span>{certificate.authorisation_number}</span>
//         </div>
//         <div className={styles.detailItem}>
//           <strong>Category of Specialization:</strong>{" "}
//           <span>{certificate.specialisation_category}</span>
//         </div>
//         <div className={styles.detailItem}>
//           <strong>Issue Date:</strong>{" "}
//           <span>{certificate.certificate_issue}</span>
//         </div>

//         <div className={styles.detailItem}>
//           <strong>Additional Remark:</strong>{" "}
//           <span>{certificate.additional_details || "N/A"}</span>
//         </div>
//       </div>
//       {showDeleteModal && (
//         <DeleteBox
//           deleteFunction={handleDelete}
//           isSuccess={certificateDeleted}
//           isError={deletionError}
//           contentName={certificate.title}
//           setShowDeleteModal={setShowDeleteModal}
//         />
//       )}
//     </div>
//   );
// };

// export default CertificateDetails;

import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styles from "../CommonStyles/commonstylesDetails.module.scss";
import { useFetchPartnerDetails } from "../../../../hooks/partnerHook/usePartner";
import { useDeleteCertificate } from "../../../../hooks/partnerHook/usePartnerCertificates";
import { FiMoreVertical } from "react-icons/fi";
import DeleteBox from "../../../../components/DeleteBox/DeleteBox";
import { useSelector } from "react-redux";

const CertificateDetails = () => {
  const { certificateId } = useParams();
  const navigate = useNavigate();
  const { data: partnerData, isLoading, isError } = useFetchPartnerDetails();

  const certificate = useSelector((state) =>
    state.partner.certificates.find(
      (cert) => cert.certificate_id.toString() === certificateId
    )
  );



  const {
    mutate: deleteCertificate,
    isSuccess: certificateDeleted,
    isError: deletionError,
  } = useDeleteCertificate();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  if (isLoading) return <h2>Loading Certificate Details...</h2>;
  if (isError || !certificate) return <h2>Error: Certificate not found!</h2>;

  const handleDelete = () => {
    if (certificateId) {
      deleteCertificate({ partnerId: partnerData.partner.id, certificateId });
      setShowDeleteModal(false);
      navigate("/dashboard/certificates");
    }
  };

  const handleEdit = () => {
    navigate(`/dashboard/certificates/edit-certificate/${certificateId}`);
  };

  return (
    <div className={styles.detailsContainer}>
      <div className={styles.titleContainer}>
        <h2 className={styles.equipmentTitle}>{certificate.title}</h2>
        <div className={styles.menuWrapper}>
          <FiMoreVertical
            className={styles.menuIcon}
            onClick={() => setMenuOpen((prev) => !prev)}
          />
          {menuOpen && (
            <div className={styles.dropdownMenu}>
              <button onClick={handleEdit}>Edit</button>
              <button onClick={() => setShowDeleteModal(true)}>Delete</button>
            </div>
          )}
        </div>
      </div>

      <div className={styles.imageCard}>
        <img
          src={certificate.media?.[0]?.media_url || "/default-image.jpg"}
          alt={certificate.title}
          className={styles.equipmentImage}
        />
        <span
          className={`${styles.verificationStatus} ${
            certificate.verification_status === "success"
              ? styles.verified
              : styles.notVerified
          }`}
        >
          {certificate.verification_status === "success"
            ? "Verified"
            : "Not Verified"}
        </span>
      </div>

      <div className={styles.equipmentDetails}>
        <div className={styles.detailItem}>
          <strong>Certificate Number:</strong>{" "}
          <span>{certificate.certificate_number}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Training Institute Name:</strong>{" "}
          <span>{certificate.institute_name}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Training Authorization Number:</strong>{" "}
          <span>{certificate.authorisation_number}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Category of Specialization:</strong>{" "}
          <span>{certificate.specialisation_category}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Issue Date:</strong>{" "}
          <span>{certificate.certificate_issue}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Additional Remark:</strong>{" "}
          <span>{certificate.additional_details || "N/A"}</span>
        </div>
      </div>

      {showDeleteModal && (
        <DeleteBox
          deleteFunction={handleDelete}
          isSuccess={certificateDeleted}
          isError={deletionError}
          contentName={certificate.title}
          setShowDeleteModal={setShowDeleteModal}
        />
      )}
    </div>
  );
};

export default CertificateDetails;
